import { copy, isDate } from "angular"
import { sum } from "../omnia"
import { getProductUnitsTextNormalizedFromApplication } from "../services/units"
import { StockVm } from "../stocks/stockVm"
import { INtrApp, INutritionPlanProductApp, INutritionProductApp, INutritionService, NutrientType, ProductAppInput } from "../types"
import { isNumber } from "@omnia/shared/utils/utils"

export class ApplicationVm implements INutritionProductApp {

    public readonly apps: INtrApp[]

    public readonly productAmountUnits = getProductUnitsTextNormalizedFromApplication(this.productApp)

    public readonly averageProductRate : number

    constructor(
        public readonly productApp: INutritionPlanProductApp,
        public readonly stock: StockVm,
        private readonly svc: INutritionService,
        public readonly planId = productApp.NutritionPlanId,
        public readonly appId = productApp.NutritionPlanProductAppId,
        public readonly fertiliserId = productApp.FertiliserId,
        public readonly manureId = productApp.ManureId,
        public readonly applicationDate = (productApp.ActualDate ?? productApp.ApplicationDate)?.toISOString(),
        public readonly referenceDate = productApp.ActualDate ?? productApp.ApplicationDate
    ) {

        this.apps = this.svc.getApplications().filter(a => a.AppId === productApp.NutritionPlanProductAppId)

        this.averageProductRate = getProductRate(productApp, this.apps)
    }


    get averageNutrientPct(): number {
        return this.productApp.NutrientPct
    }

    isLiquid(): boolean {
        return this.stock && this.stock.isLiquid()
    }

    isSolid(): boolean {
        return !this.isLiquid()
    }

    isManure() {
        return this.stock && this.stock.isManure()
    }

    isLime() {
        const app = this.productApp
        const tn = app ? app.TargetNutrient : 0
        return tn == NutrientType.Lime
    }

    get description(): string {
        if (this.stock) {
            return this.stock.description
        }
    }

    hasActualData(): boolean {
        return !!this.productApp.ActualDate || !!this.productApp.ActualRate
    }

    hasValidApplicationDate(): boolean {
        return isDate(this.productApp.ApplicationDate)
    }

    hasValidActualData(): boolean {
        return isDate(this.productApp.ActualDate) && isNumber(this.productApp.ActualRate)
    }

    get actualDate(): Date {
        return this.productApp.ActualDate
    }

    get actualRate(): number {
        return this.productApp.ActualRate
    }

    get productAmount(): number {
        var apps = this.apps.filter(a => !a.Zone)
        return Math.round((apps.length ? sum(apps, a => a.ProductAmount) : 0) * 10) / 10
    }

}


function getProductRate(app: INutritionPlanProductApp, cropping: INtrApp[]) {

    const zones = cropping.filter(a => a.Zone && !a.Aggregate)
    const fields = cropping.filter(a => !a.Zone)

    const records = zones.length ? zones : fields

    const distinctRates = records.map(r => r.ProductRate || 0).unique(r => r)

    if ((app.LastInputUsed === ProductAppInput.ProductRate) && (distinctRates.length <= 1)) {

        return app.ProductRate

    }

    const totalArea = sum(records, a => a.Area)
    const total = sum(records, a => a.ProductRate * a.Area)
    let avg = total / totalArea

    avg = Math.round(avg * 100) / 100

    return avg || 0

}